import { cn } from '@/lib/utils';

/**
 * 2〜3 個の排他的な選択。表示の切り替え (見る軸・並び) に使う。
 *
 * 現在地はブランド色。角丸も影も無いので、境界は 1px のボーダーだけで作る。
 */
export function Segmented<T extends string>({
  value,
  onChange,
  options,
  label,
  className,
}: {
  value: T;
  onChange: (value: T) => void;
  options: Array<{ value: T; label: string }>;
  /** スクリーンリーダー向けの群の名前 */
  label: string;
  className?: string;
}) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={cn('inline-flex border border-line-strong', className)}
    >
      {options.map((option, index) => (
        // biome-ignore lint/a11y/useSemanticElements: 見た目が地続きのセグメントなので input[type=radio] にできない。radiogroup/radio は正規の ARIA パターン
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={value === option.value}
          onClick={() => onChange(option.value)}
          className={cn(
            'px-3 py-1.5 text-xs',
            index > 0 && 'border-l border-line-strong',
            value === option.value
              ? 'bg-brand-700 text-surface-raised'
              : 'text-ink-muted hover:bg-surface',
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
